import SwitchInfoTooltip from "./SwitchInfoTooltip";
import { Input } from "src/@/components/ui/input";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "src/@/components/ui/select";
import { Switch } from "src/@/components/ui/switch";
import Iconify from "src/components/Iconify";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "src/@/components/ui/tooltip";

export default function AutomationOnlyExecute({ actionState, changeActionState }) {
  return (
    <div className="block">
      <SwitchInfoTooltip
        checked={actionState?.executeOnlyTime}
        onCheckedChange={(checked) =>
          changeActionState({ name: "executeOnlyTime", value: checked })
        }
        label="Executar 1 vez (recomendado)"
        info="Se o chat tiver chances de receber a mesma automação mais de uma vez, mantenha este campo desmarcado."
        className="mt-8"
      />

      {actionState?.executeOnlyTime && (
        <div className="mt-4 ml-6 pl-4 border-l-2 border-slate-200 animate-in fade-in slide-in-from-top-2">
          <div className="flex items-center space-x-2 mb-4">
            <Switch
              id="validity-switch"
              checked={actionState?.isExecuteValidity}
              onCheckedChange={(checked) => {
                changeActionState({ name: "isExecuteValidity", value: checked });
                if (checked) {
                  changeActionState({ name: "executeValidityValue", value: "" });
                  changeActionState({ name: "executeValidityUnit", value: "hours" });
                } else {
                  changeActionState({ name: "executeValidityValue", value: null });
                  changeActionState({ name: "executeValidityUnit", value: null });
                }
              }}
            />
            <div className="flex items-center gap-2">
              <label
                htmlFor="validity-switch"
                className="text-sm font-medium text-slate-700 cursor-pointer select-none"
              >
                Definir validade da regra
              </label>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <span tabIndex={0} className="flex items-center">
                      <Iconify
                        icon="mdi:information-outline"
                        width={18}
                        className="text-slate-500 cursor-pointer"
                      />
                    </span>
                  </TooltipTrigger>
                  <TooltipContent side="top" align="center" className="w-[270px]">
                    Tempo que a regra de "executar apenas 1 vez" permanecerá válida.
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
          </div>

          {actionState?.isExecuteValidity && (
            <div className="animate-in fade-in slide-in-from-top-2">
              <label className="text-sm font-medium text-slate-700 mb-2 block">
                Tempo de validade
              </label>
              <div className="flex items-center gap-2">
                <Input
                  type="number"
                  min="1"
                  placeholder="Tempo"
                  className="w-24"
                  value={actionState?.executeValidityValue ?? ''}
                  onChange={(e) =>
                    changeActionState({ name: "executeValidityValue", value: e.target.value })
                  }
                />
                <Select
                  value={actionState?.executeValidityUnit || "hours"}
                  onValueChange={(value) =>
                    changeActionState({ name: "executeValidityUnit", value: value })
                  }
                >
                  <SelectTrigger className="w-32">
                    <SelectValue placeholder="Selecione" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="hours">Horas</SelectItem>
                    <SelectItem value="days">Dias</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <p className="text-xs text-slate-500 mt-2">
                Tempo que a regra de "executar apenas 1 vez" permanecerá válida.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
